import React, { FC } from 'react';
import { useIntl } from 'react-intl';
import { Notifications } from '@material-ui/icons';
import messages from 'modules/booking/messages';
import { ActionItem } from 'common/components';
import ActionItemWarningIcon from 'common/components/ActionsMenu/ActionItemWarningIcon';
import BookingActionItemContainer from 'components/Booking/BookingActionItemContainer';

interface IBookingActionItemRemind {
  onClick: () => void;
  isEventCanceled: boolean;
}

const BookingActionItemRemind: FC<IBookingActionItemRemind> = ({ onClick, isEventCanceled }) => {
  const intl = useIntl();
  let disableReason: JSX.Element | null = null;

  if (isEventCanceled) {
    disableReason = (
      <ActionItemWarningIcon tooltipMessage={intl.formatMessage(messages.eventIsCanceled)} />
    );
  }

  const disabled = !!disableReason;

  return (
    <ActionItem
      key="remindEventAction"
      disabled={disabled}
      onClick={!disabled ? onClick : undefined}
      icon={<Notifications />}
    >
      <BookingActionItemContainer message={intl.formatMessage(messages.remindParticipants)}>
        {disableReason}
      </BookingActionItemContainer>
    </ActionItem>
  );
};

export default BookingActionItemRemind;
